module.exports = __webpack_public_path__ + "ToyotaType-Bold.7d6db386a3baf7fb13e8.otf";


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/assets/mygolf-theme/fonts/toyota/ToyotaType-Bold.otf
// module id = ../../../../../src/assets/mygolf-theme/fonts/toyota/ToyotaType-Bold.otf
// module chunks = styles